import { CSSProperties } from 'react'
import { css, styled } from 'styled-components'

import { Container } from 'designSystem'

export const TextEditorWrapper = styled(Container)<{
  isReadOnly?: boolean
  height: CSSProperties['height']
  minHeight: CSSProperties['minHeight']
  maxHeight: CSSProperties['maxHeight']
}>`
  &&& .ck-toolbar {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.underline};
    border: 1px solid ${({ theme }) => theme.colors.lines};
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-top: 0;
    min-height: 50px;
  }

  &&& .ck-content {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.lines};
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    &.ck-focused {
      box-shadow: none;
    }

    ${({ isReadOnly }) =>
      isReadOnly &&
      css`
        border: none;
        padding: 0;

        & > *:first-child {
          margin-top: 0;
        }
      `}

    ${({ height }) => {
      if (height && typeof height === 'number') {
        return css`
          height: ${height}px;
        `
      }

      return css`
        height: ${height};
      `
    }}

    ${({ minHeight }) => {
      if (minHeight && typeof minHeight === 'number') {
        return css`
          min-height: ${minHeight}px;
        `
      }

      return css`
        min-height: ${minHeight};
      `
    }}

    ${({ maxHeight }) => {
      if (maxHeight && typeof maxHeight === 'number') {
        return css`
          max-height: ${maxHeight}px;
        `
      }

      return css`
        max-height: ${maxHeight};
      `
    }}
  }

  .ck-toolbar__items {
    justify-content: space-around;
  }

  ul,
  ol {
    padding-left: ${({ theme }) => theme.spacers[9]};
  }
`
